import { SignIn, SignUp } from './models';
import { PaginatableCollection } from '../../base/store/collections';

export const state = {
  submitErrorAddress: false,
  submitErrorPaymentInfo: false,
  orders: new PaginatableCollection(),
  partnerInfo: null,
  redirect: true,
  signIn: new SignIn(),
  signUp: new SignUp(),
};

export const mutations = {
  setPartnerInfo(state, partnerInfo) {
    state.partnerInfo = partnerInfo;
  },

  clearPartnerInfo(state) {
    state.partnerInfo = null;
  },
};